export default __webpack_public_path__ + "static/media/Ballroll_00347.fb2c794e.png";